/**
 * Headline `total = subtotal + tax.total`. Trivially small but exposed
 * so consumers can compose it without re-stating the formula and so
 * `AmountService.calcTotal` can delegate.
 */
export function computeTotal(subtotal: number, taxTotal: number): number {
  return subtotal + taxTotal;
}

/**
 * `remaining = total - paid`, with `paid >= total` collapsing it to
 * zero. Pure mirror of `AmountService.calcRemaining` — the special
 * case is what stops over-payment from producing a negative remaining.
 */
export function computeRemaining(total: number, paid: number): number {
  if (paid >= total) return 0;
  return total - paid;
}
